var React = require('react');

function Activity (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("g",{"stroke":"#006A35","key":0},[React.createElement("path",{"d":"M.5 2.159h19v15.587H.5z","key":0}),React.createElement("path",{"strokeLinecap":"round","d":"M5.833.83v3.317M14.167.83v3.317","key":1}),React.createElement("path",{"strokeLinecap":"square","d":"M.833 7.464h18.334","key":2}),React.createElement("path",{"strokeLinecap":"round","d":"M3.258 10.782h7.5M3.258 14.1H8.59","key":3})]),React.createElement("ellipse",{"cx":"15.958","cy":"13.909","fill":"#FFF","rx":"5.958","ry":"5.909","key":1}),React.createElement("ellipse",{"cx":"16.066","cy":"13.859","stroke":"#006332","strokeWidth":".926","rx":"4.583","ry":"4.545","key":2}),React.createElement("path",{"stroke":"#006A35","strokeLinecap":"round","strokeWidth":".926","d":"M14.166 14.164l1.339 1.257 2.53-3.19","key":3})]));
}

Activity.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = Activity;

Activity.default = Activity;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/activity.svg
// module id = 1464
// module chunks = 0